module.exports = __webpack_public_path__ + "static/img/banner3.2f77d37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner3.png
// module id = kd5c
// module chunks = 0